import { JsonObject } from 'ta-json';
import { WoodType, WoodTypeAvailable } from '@ess/jg-rule-executor';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_woodTypesAvailable,
} from '@src/app/generated/GetAllRetailers';
import { WoodTypeAvailableInput } from '@src/app/generated/globalTypes';

/**
 * Extension of WoodTypeAvailable to convert from-and-to gql object
 */
@JsonObject()
export class PortalWoodTypeAvailable extends WoodTypeAvailable {
  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_woodTypesAvailable
  ): PortalWoodTypeAvailable {
    return new PortalWoodTypeAvailable(
      WoodType[gql.woodType],
      gql.available
    );
  }

  toGqlInput(): WoodTypeAvailableInput {
    return {
      woodType: this.woodType,
      available: this.available,
    };
  }
}
